import React, { useState } from "react";
import { CommandBarButton, Aside } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../core/security/SprintAccessRight";
import { CreateDeliveryBucketForm } from "./CreateDeliveryBucketForm";

export const AddDeliveryBucketButton: React.VFC = () => {
    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const openAside = () => {
        setIsAsideOpen(true);
    };

    const closeAside = () => {
        setIsAsideOpen(false);
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiAdmin]}>
            <CommandBarButton onClick={openAside} text="Add" icon="Add" />
            <Aside
                type="form"
                headerText="Add Delivery Bucket"
                isOpen={isAsideOpen}
                onDismiss={closeAside}
                isLightDismiss={true}
            >
                <CreateDeliveryBucketForm onSubmit={closeAside} onCancel={closeAside} />
            </Aside>
        </AuthorizationWrapper>
    );
};
